var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 0.335938H3.33268C1.85935 0.335938 0.666016 1.52927 0.666016 3.0026V19.0026C0.666016 20.4759 1.85935 21.6693 3.33268 21.6693H24.666C26.1393 21.6693 27.3327 20.4759 27.3327 19.0026V3.0026C27.3327 1.52927 26.1393 0.335938 24.666 0.335938ZM7.33268 17.6693H4.66602V15.0026H7.33268V17.6693ZM8.66602 8.33594H4.66602V4.33594H8.66602V8.33594ZM12.666 17.6693H9.99935V15.0026H12.666V17.6693ZM17.9993 17.6693H15.3327V15.0026H17.9993V17.6693ZM23.3327 17.6693H20.666V15.0026H23.3327V17.6693ZM23.3327 8.33594H15.3327V5.66927H23.3327V8.33594Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.bcbb4a5869e89192786ea31c5dc43b2b.svg";
export { ForwardRef as ReactComponent };